import { render, staticRenderFns } from "./Scrapes.vue?vue&type=template&id=d2a7a664&"
import script from "./Scrapes.vue?vue&type=script&lang=js&"
export * from "./Scrapes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports